<template>
  <div class="pdf-container">
    <!-- PDF 渲染区域 -->
    <div id="pdf-viewer" ref="pdfViewer" v-show="pdfUrl">
      <canvas ref="pdfCanvas"></canvas>
    </div>
    <van-empty description="无服务凭证" v-if="!pdfUrl" />

    <!-- 签名区域 -->
    <div class="signature-box">
      <p class="signature-title" ref="title">客户签字区：</p>
      <canvas
        ref="signatureCanvas"
        class="signature-pad"
        @touchstart.prevent
        @touchmove.prevent
      ></canvas>
      <div class="signature-buttons">
        <van-button type="default" size="small" @click="clearSignature"
          >重新签字</van-button
        >
        <van-button type="info" size="small" @click="uploadSignature"
          >提交签字</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import SignaturePad from "signature_pad";
import axios from "axios";
import { signInfo, remoteSign } from "@/api/sign";

export default {
  data() {
    return {
      pdfUrl: "",
      signaturePad: null,
      pdfDoc: null,
      code: "",
      detail: {},
    };
  },
  created() {
    this.code = this.$route.query.code;
    this.signInfo();
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.enableZoom()
    // this.loadPdf();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    enableZoom() {
      const meta = document.querySelector('meta[name="viewport"]')
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0')
    },
    async signInfo() {
      let code = this.$route.query.code;
      if (!code) {
        this.$toast.fail("该签署链接无签约码");
        return;
      }
      let res = await signInfo({ signCode: code });
      if (res.success) {
        this.pdfUrl = location.hostname == 'localhost' || location.hostname == '192.168.1.83' ? res.content.voucherUrl?.replace(/^https?:\/\/[^\/]+/, "/pdfproxy") || '' : res.content.voucherUrl || "";
        this.detail = res.content;
      } else {
        this.$toast.fail(res.respMag || res.msg);
      }
      this.$nextTick(() => {
        this.loadPdf();
      });
    },
    // 当屏幕大小变化时重新渲染
    onResize() {
      if (this.pdfDoc) {
        this.renderPdfPage(1);
        this.resizeSignatureCanvas();
      }
    },

    // 加载 PDF
    async loadPdf() {
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";
      this.initSignaturePad();
      const loadingTask = pdfjsLib.getDocument(this.pdfUrl);
      this.pdfDoc = await loadingTask.promise;
      await this.renderPdfPage(1);
    },

    // 渲染 PDF 指定页面
    async renderPdfPage(pageNum) {
      const page = await this.pdfDoc.getPage(pageNum);
      const containerWidth = this.$refs.pdfViewer.clientWidth;
      const viewport = page.getViewport({ scale: 1 });

      // 根据容器宽度计算缩放比例
      const scale = containerWidth / viewport.width;
      const scaledViewport = page.getViewport({ scale });

      const canvas = this.$refs.pdfCanvas;
      const context = canvas.getContext("2d");

      // 关键：处理高清屏
      const dpr = window.devicePixelRatio || 1;
      canvas.width = scaledViewport.width * dpr;
      canvas.height = scaledViewport.height * dpr;
      canvas.style.width = scaledViewport.width + "px";
      canvas.style.height = scaledViewport.height + "px";

      // 缩放 context，使渲染内容清晰
      context.setTransform(dpr, 0, 0, dpr, 0, 0);

      await page.render({
        canvasContext: context,
        viewport: scaledViewport,
      }).promise;
    },
    // 初始化签名板
    initSignaturePad() {
      this.resizeSignatureCanvas();
      this.signaturePad = new SignaturePad(this.$refs.signatureCanvas, {
        backgroundColor: "#fff",
        penColor: "black",
      });
    },

    // 根据屏幕宽度调整签名区域
    resizeSignatureCanvas() {
      const canvas = this.$refs.signatureCanvas;
      const containerWidth = this.$refs.title.clientWidth;

      canvas.width = containerWidth;
      canvas.height = 200;

      if (this.signaturePad) {
        this.signaturePad.clear(); // 调整后清空签名
      }
    },

    // 清除签名
    clearSignature() {
      this.signaturePad.clear();
    },

    // Base64 转 Blob
    base64ToBlob(base64) {
      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    // 上传签名
    async uploadSignature() {
      if (!this.code) {
        this.$toast.fail("该签署链接无签约码");
        return;
      }
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        this.$toast.fail("请先签名");
        return;
      }
      this.$dialog
        .confirm({
          title: "提交签名",
          message: `是否提交该客户签名信息`,
        })
        .then(async () => {
          const base64Data = this.signaturePad.toDataURL("image/png");
          const blob = this.base64ToBlob(base64Data);

          const formData = new FormData();
          formData.append("signImage", blob, "signature.png");
          formData.append("signCode", this.code);
          console.log(formData);
          let res = await remoteSign(formData);
          if (res.success) {
            this.$toast(res.respMag || res.msg || "提交成功");
            return true;
          } else {
            this.$toast.fail(res.respMag || res.msg || "提交失败");
            return false;
          }
        });
      // axios
      //   .post("/api/upload/signature", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((res) => {
      //     console.log("上传成功:", res.data);
      //     alert("签名已上传成功");
      //   })
      //   .catch((err) => {
      //     console.error("上传失败:", err);
      //     alert("签名上传失败");
      //   });
    },
  },
};
</script>

<style scoped>
.pdf-container {
  padding: 10px;
  padding-bottom: 64px;
}

#pdf-viewer {
  width: 100%;
  overflow-x: auto;
  /* margin-bottom: 20px; */
}

.signature-box {
  text-align: center;
}

.signature-pad {
  border: 1px solid #ccc;
  background: #fff;
  margin:  0 16px;
}

.signature-buttons {
  margin-top: 10px;
  padding: 0 16px;
  display: flex;
  justify-content: flex-end;
}

button {
  padding: 6px 12px;
  margin: 0 5px;
  border: none;
  background: #007bff;
  color: #fff;
  border-radius: 4px;
}

button:hover {
  background: #0056b3;
}
.signature-title {
  margin: 0 16px;
  margin-bottom: 16px;
}
</style>
